import React from "react";
import { size, COLORS } from "../../utils";
import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import projects from '../../assets/lottiefiles/projects.json';
import Lottie from 'react-lottie';

export default function Intro() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // true for screen < 600px

    return (
        <Grid
            item
            container
            flexWrap={'nowrap'}
            direction={'column'}
            alignItems={'center'}
            justifyContent={'center'}
            width={isMobile ? '100%' : size({ p: 70 })}
            height={isMobile ? 'auto' : size({ p: 100, h: true })}
            px={isMobile ? 2 : 0}
            py={isMobile ? 4 : 0}
        >
            <Grid
                item
                container
                flexWrap={'nowrap'}
                direction={'column'}
                rowGap={isMobile ? 2 : size({ p: 1, h: true })}
            >
                <Grid item>
                    <Typography
                        sx={{
                            fontFamily: 'Archia',
                            fontSize: isMobile ? '1.4rem' : size({ p: 2.2 }),
                            fontWeight: 600,
                            textAlign: 'center',
                            color: COLORS.C2,
                            px: isMobile ? 2 : size({ p: 10 }),
                            mt:'2.5rem'
                        }}
                    >
                        Take a smarter approach to your final year projects with Genesys
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography
                        sx={{
                            fontFamily: 'Archia',
                            fontSize: isMobile ? '0.95rem' : size({ p: 1 }),
                            fontWeight: 400,
                            textAlign: 'center',
                            color: `${COLORS.C1}A0`,
                            px: isMobile ? 2 : size({ p: 5 }),
                        }}
                    >
                        Elevate your final year projects with Genesys – where innovation meets expertise. Take a smarter approach as we guide you through cutting-edge solutions and empower your projects to stand out in the tech landscape. Transform your ideas into successful realities with Genesys by your side.
                    </Typography>
                </Grid>
            </Grid>
            <Grid item mt={isMobile ? 3 : size({ p: 3, h: true, neg: true })}>
                <Lottie
                    width={isMobile ? 250 : size({ p: 35 })}
                    height={isMobile ? 250 : size({ p: 35 })}
                    options={{
                        loop: true,
                        autoplay: true,
                        animationData: projects,
                    }}
                />
            </Grid>
        </Grid>
    );
}
